import { render, staticRenderFns } from "./ParentHeader.vue?vue&type=template&id=676d10a3&scoped=true&"
import script from "./ParentHeader.vue?vue&type=script&lang=js&"
export * from "./ParentHeader.vue?vue&type=script&lang=js&"
import style0 from "./ParentHeader.vue?vue&type=style&index=0&id=676d10a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d10a3",
  null
  
)

export default component.exports